import { RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';
import { LlamadasComponent } from './reportes/llamadas/llamadas.component';
import { SeguimientoComponent } from './seguimiento.component';
import { GestionCobrosComponent } from './reportes/gestion-cobros/gestion-cobros.component';
import { CobrosRecuperadorComponent } from './reportes/cobros-recuperador/cobros-recuperador.component';
import { TarjetasCreditoActualizadasComponent } from './reportes/tarjetas-credito-actualizadas/tarjetas-credito-actualizadas.component';

@NgModule({
    imports: [
        RouterModule.forChild([
            {
                path: '', component: SeguimientoComponent
                ,
                children: [
     			    { path: '', redirectTo: 'reportes/informe-llamadas', pathMatch: 'full' },
                    { path: 'reportes/informe-llamadas', component: LlamadasComponent },
                    { path: 'reportes/gestion-cobros', component: GestionCobrosComponent },
                    { path: 'reportes/cobros-recuperador', component: CobrosRecuperadorComponent },
                    { path: 'reportes/tarjetas-credito-actualizadas', component: TarjetasCreditoActualizadasComponent },
                ]
            },
            {path: '**', redirectTo: '/notfound'},
        ])
    ],
    exports: [RouterModule]
})
export class SeguimientoRoutingModule {
}
